import { SortablejsModule } from 'ngx-sortablejs';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { FqLoggerModule } from '@frequence/ui-kit/fq-logger';

import { CoreModule } from '../core/core.module';
import { AnalyticsModule } from './analytics/analytics.module';
import { AppComponent } from './app.component';
import { environment } from '../../environments/environment';

@NgModule({
	bootstrap: [AppComponent],
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		CommonModule,
		ReactiveFormsModule,
		HttpClientModule,
		RouterModule,
		AnalyticsModule,
		CoreModule,
		SortablejsModule,
		RouterModule.forRoot([], { useHash: false }),
		FqLoggerModule.forRoot({ ...environment })
	],
	providers: []
})
export class AppModule {}
